import { render, staticRenderFns } from "./dc-plant-sel-page.vue?vue&type=template&id=54563366&scoped=true"
import script from "./dc-plant-sel-page.vue?vue&type=script&lang=js"
export * from "./dc-plant-sel-page.vue?vue&type=script&lang=js"
import style0 from "./dc-plant-sel-page.vue?vue&type=style&index=0&id=54563366&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54563366",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54563366')) {
      api.createRecord('54563366', component.options)
    } else {
      api.reload('54563366', component.options)
    }
    module.hot.accept("./dc-plant-sel-page.vue?vue&type=template&id=54563366&scoped=true", function () {
      api.rerender('54563366', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/fpaManage/fpaPermanent/dc-plant-sel-page.vue"
export default component.exports